import React, { Component } from 'react'

export class ProgressBar extends Component {
    constructor(props) {
        super(props)

        this.state = {
            progress: this.props.progress
        }
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-2 text-center">File Upload</div>
                    <div className="col-2 text-center">Header Mapping</div>
                    <div className="col-2 text-center">Location Cleaning</div>
                    <div className="col-2 text-center">Vendor Cleaning</div>
                    <div className="col-2 text-center">Truck Asset Cleaning</div>
                    <div className="col-2 text-center">Final Data</div>
                </div>
                <div className="progress">
                    <div className="progress-bar progress-bar-success" role="progressbar" style={{ width: this.state.progress, height: "100%" }}></div>
                </div>
            </div>
        )
    }
}

export default ProgressBar
